var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[(_vm.minisite && _vm.minisite.headerPath)?_c('div',{attrs:{"id":"minisite-header"}},[_c('img',{attrs:{"alt":"Header Image","src":_vm.minisite.headerPath}})]):_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }